<template>
  <SimpleTable
    ref="table"
    :columns="columnDefinition"
    :data="rows"
    :highlight="highlightSelected"
    :disable-internal-sort="true"
    fixed-header
    @sorted="onSorted"
    @scroll="onScroll"
  >
    <template slot="area" slot-scope="{value}">
      <span>{{ value | formatAsHectare }}</span>
    </template>
  </SimpleTable>
</template>

<script>
import {mapActions} from 'vuex'

import {mapResources} from '@helpers/vuex'

import SimpleTable from '@components/table/SimpleTable'

import {formatAsHectare} from '@realestate/filters/numberFormatters'
import makeSelectionMixin from '@realestate/mixins/SelectionMixin'

export default {

  components: {
    SimpleTable
  },

  filters: {
    formatAsHectare
  },

  mixins: [
    makeSelectionMixin('table')
  ],

  props: {
    rows: Array
  },

  data () {
    return {

      highlightSelected: (row) => {
        if (this.selection.table.includes(row)) {
          return ['success']
        }
        return []
      }
    }
  },

  computed: {
    ...mapResources([
      '@realestate.SR_RealEstate',
      'ModelProperties.SR_ModelProperties'
    ]),

    columnDefinition () {
      return {
        documentNumber: {
          title: this.SR_RealEstate.ContractNumber,
          sortable: true,
          width: '20%'
        },
        runtimeStart: {
          title: this.SR_ModelProperties.TermFrom,
          type: 'date',
          sortable: true,
          width: '13%'
        },
        runtimeEnd: {
          title: this.SR_ModelProperties.TermTo,
          type: 'date',
          sortable: true,
          width: '9%'
        },
        lessor: {
          title: this.SR_ModelProperties.Lessor,
          width: '19%'
        },
        leaser: {
          title: this.SR_ModelProperties.Leaser,
          width: '10%'
        },
        area: {
          title: this.SR_RealEstate.Size,
          sortable: true,
          width: '14%'
        },
        businessObject: {
          title: this.SR_RealEstate.BusinessObject,
          width: '10%'
        }
      }
    }
  },

  methods: {
    ...mapActions('realEstate', [
      'loadDataForTableSelection'
    ]),

    onSelected (selectedItems) {
      if (selectedItems && selectedItems.length === 1) {
        this.loadDataForTableSelection(`/realestate/Lease/GetContract?id=${selectedItems[0].uid}`)
      } else {
        // TODO: load data for multiple selection
      }
    },

    onSorted (sortedEventArgs) {
      this.$emit('sorted', sortedEventArgs)
    },

    onScroll (scrollEvent) {
      this.$emit('scroll', scrollEvent)
    }
  },

  mounted () {
    this.$on('selected', this.onSelected)
  }
}

</script>

<style lang="scss">

</style>
